import { BalanceScaleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Card } from "shared/components/Card";

export const NoRecommendationCard = () => {
  return (
    <Card className="w-[300px] min-h-[274px] p-6 flex flex-col items-center justify-center shrink-0">
      <div className="h-[100px] w-[100px] flex items-center justify-center rounded-full bg-alpha-20">
        <HugeiconsIcon
          icon={BalanceScaleIcon}
          className="text-content-300"
          size={40}
        />
      </div>

      <h2 className="text-base text-content-500 font-bold mt-6 mb-2 text-center">
        No recommendation
      </h2>

      <p className="text-sm text-content-300 font-medium text-center">
        Decision recommendations have been disabled in the screening settings
        for this application
      </p>
    </Card>
  );
};
